module.exports = __webpack_public_path__ + "img/arrived_icon.60c07b10.svg";